import { useEffect, useState } from "react";
import { motion, useScroll } from "framer-motion";

/**
 * Slim teal reading progress bar at the very top of the page.
 * Activates after the user has scrolled past the hero.
 */
export default function ReadingProgress() {
  const { scrollYProgress } = useScroll();
  const [active, setActive] = useState(false);

  useEffect(() => {
    const onScroll = () => setActive(window.scrollY > 200);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.div
      data-testid="reading-progress"
      aria-hidden="true"
      style={{ scaleX: scrollYProgress }}
      className={`fixed top-0 left-0 right-0 h-[2px] bg-[var(--sci-teal)] origin-left z-[60] transition-opacity duration-300 ${
        active ? "opacity-100" : "opacity-0"
      }`}
    />
  );
}
